import { render, staticRenderFns } from "./CollectionActionEscalate.vue?vue&type=template&id=72c8ff0a&scoped=true&"
import script from "./CollectionActionEscalate.vue?vue&type=script&lang=ts&"
export * from "./CollectionActionEscalate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c8ff0a",
  null
  
)

export default component.exports